import React from "react";
import { LAYER_COLORS } from "./api";

/** Pre-Con / Ops / Field, then per Bluebeam layer and per author. Installer default = Field on,
 *  Pre-Con takeoff off; office default = everything. */
export default function LayerPanel({ layers, authors, hidden, toggle, hiddenAuthors, toggleAuthor,
                                     showSpaces, setShowSpaces, counts, onAll, onNone }) {
  return (
    <div className="space-y-2 text-sm" data-testid="layer-panel">
      <div className="flex items-center gap-2">
        <div className="text-[11px] uppercase tracking-wide text-neutral-500 font-semibold flex-1">Layers</div>
        <button type="button" onClick={onAll} className="text-[11px] underline text-neutral-600" data-testid="layers-select-all">Select all</button>
        <button type="button" onClick={onNone} className="text-[11px] underline text-neutral-600" data-testid="layers-select-none">Deselect all</button>
      </div>
      {layers.map((l) => (
        <label key={l} className="flex items-center gap-2 cursor-pointer" data-testid={`layer-toggle-${l.replace(/\s+/g, "-")}`}>
          <input type="checkbox" checked={!hidden.has(l)} onChange={() => toggle(l)} className="accent-orange-500 w-4 h-4" />
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: LAYER_COLORS[l] || "#64748b" }} />
          <span className="flex-1 truncate">{l || "(no layer)"}</span>
          <span className="text-xs text-neutral-400">{counts?.[l] || 0}</span>
        </label>
      ))}
      <label className="flex items-center gap-2 cursor-pointer pt-1 border-t border-neutral-200" data-testid="layer-toggle-spaces">
        <input type="checkbox" checked={showSpaces} onChange={(e) => setShowSpaces(e.target.checked)} className="accent-orange-500 w-4 h-4" />
        <span className="flex-1">Spaces (rooms)</span>
      </label>
      {authors.length > 0 && (
        <>
          <div className="text-[11px] uppercase tracking-wide text-neutral-500 font-semibold pt-2">Authors</div>
          {authors.map((a) => (
            <label key={a} className="flex items-center gap-2 cursor-pointer" data-testid={`author-toggle-${a.replace(/\s+/g, "-")}`}>
              <input type="checkbox" checked={!hiddenAuthors.has(a)} onChange={() => toggleAuthor(a)} className="accent-orange-500 w-4 h-4" />
              <span className="flex-1 truncate">{a}</span>
            </label>
          ))}
        </>
      )}
    </div>
  );
}
